import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { ROUTES } from 'constants.js';
import useTranslation from 'utils/hooks/useTranslation';
import useAmplitude from 'utils/hooks/useAmplitude';
import { AMPLITUDE_EVENT_TYPES, AMPLITUDE_WALLET_PROPERTY_VALUES } from 'constants/amplitude';

import styles from './style.module.scss';

const SpentThisMonth = ({ amount, inactive = false }) => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();
  const handleReportsLinkClick = () =>
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletReportsLinkClicked, {
      linkSource: AMPLITUDE_WALLET_PROPERTY_VALUES.linkSource.spentThisMonth,
    });

  return (
    <div
      className={classNames(styles.statCard, { [styles.statCardInactive]: inactive })}
      data-testid="walletSpentThisMonth"
    >
      <div className={styles.statHeader}>
        <span className={styles.statLabel}>
          {translateText('corporateAccounts.wallet.dashboard.spentThisMonth.label')}
        </span>
      </div>
      <div className={`${styles.statValue} ${styles.statValueSmall}`}>{amount}</div>
      <div className={`${styles.statSub} ${styles.statSubTight}`}>
        <Link
          to={ROUTES.REPORTS}
          className={styles.link}
          data-testid="walletSpentThisMonthReportsLink"
          onClick={handleReportsLinkClick}
        >
          {translateText('corporateAccounts.wallet.dashboard.spentThisMonth.link')}
        </Link>
      </div>
    </div>
  );
};

export default SpentThisMonth;
